import { Typography, Box, Stack } from "@mui/material";
import aboutImg from "../assets/images/about.webp";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import LeafIcon from "../components/LeafIcon";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import { useInView } from "../components/hook";

export default function About() {
  const [ref, show] = useInView(0.1);
  return (
    <Box
      ref={ref}
      sx={{
        mt: 10,
        overflow:'hidden',
        width: "100%",
        display: "flex",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: { md: "100%", xs: "50%" },
            width: { md: "50%", xs: "100%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            opacity: show ? 1 : 0,
            transform: show ? "translateX(0)" : "translateX(-80px)",
            transition: "all 0.9s ease",
          }}
        >
          <Box
            sx={{
              mt: 8,
              height: "90%",
              width: "90%",
              borderRadius: "20px",
              overflow: "visible",
              position: "relative",
            }}
          >
            <Box
              sx={{
                height: "500px",
                width: "100%",
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  backgroundImage: `url(${aboutImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",

                  transition: "transform 0.7s ease",

                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "block" },
                position: "absolute",
                width: "200px",
                heigth: "50px",
                bottom: "-23px",
                right: "-40px",
                background: "rgba(255,255,255,0.92)",
                backdropFilter: "blur(6px)",
                px: 2.5,
                py: 1.5,
                borderRadius: "14px",
                boxShadow: "0 12px 30px rgba(247, 206, 149, 0.8)",

                animation: "float 3s ease-in-out infinite",

                "@keyframes float": {
                  "0%": {
                    transform: "translateY(0)",
                  },
                  "50%": {
                    transform: "translateY(-10px)",
                  },
                  "100%": {
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  fontSize: "37px",
                  color: "#f29c24",
                  lineHeight: 1,
                }}
              >
                50+
              </Typography>
              <Typography
                sx={{ fontSize: "16px", color: "#333", mt: 2, fontWeight: 600 }}
              >
                Cake Varieties
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            height: { md: "100%", xs: "50%" },
            width: { md: "50%", xs: "100%" },
            display: "flex",
            pt: 7,
            pl: 2,
            pr: 2.5,
            flexDirection: "column",
            gap: 2,
            opacity: show ? 1 : 0,
            transform: show ? "translateX(0)" : "translateX(80px)",
            transition: "all 0.9s ease",
            transitionDelay: "0.2s",

           
          }}
        >
          <Box
            sx={{
              display: "flex",
              height: "30px",
              width: "120px",
              bgcolor: "#faf1e3",
              borderRadius: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 600, color: "#e99e26ff" }}>
              Our Story
            </Typography>
          </Box>
          <Box>
            <Typography variant="h2">Where Every Slice</Typography>
            <Typography variant="h2" sx={{ color: "#e99e26ff" }}>
              Tells a Story
            </Typography>
          </Box>
          <Typography lineHeight={2} sx={{ color: "#595959ff" }}>
            Welcome to Caramel Cottage! We are a newly opened cake shop
            dedicated to bringing you freshly baked cakes made with love,
            creativity, and the finest ingredients. From classic flavors to
            custom-designed cakes for special moments, every treat is crafted to
            add sweetness to your celebrations.
          </Typography>
          <Typography lineHeight={2} sx={{ color: "#595959ff" }}>
            Our goal is simple — to create delicious cakes that not only look
            beautiful but taste unforgettable. Whether it’s a birthday,
            anniversary, or just a craving for something sweet, we’re here to
            make every moment special.
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "70px",
              display: "flex",
              cursor: "pointer",

              "&:hover .icon-box": {
                transform: "scale(1.12)",
                bgcolor: "#ffe3b5ff",
              },

              //   "&:hover .icon": {
              //     transform: "scale(1.15)",
              //   },

              "&:hover .title": {
                color: "#F29C24",
              },
            }}
          >
            <Box
              className="icon-box"
              sx={{
                height: "50px",
                width: "50px",
                bgcolor: "#fff1dbff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
                transition: "all 0.3s ease",
              }}
            >
              <FavoriteBorderIcon
                className="icon"
                sx={{
                  color: "#e99e26ff",
                  width: "25px",
                  height: "30px",
                  transition: "transform 0.6s ease",
                }}
              />
            </Box>
            <Stack sx={{ ml: 3 }}>
              <Typography
                className="title"
                variant="h5"
                sx={{
                  fontSize: "18px",
                  fontWeight: 800,
                  transition: "color 0.3s ease",
                }}
              >
                Made With Love
              </Typography>
              <Typography sx={{ color: "#595959ff", fontSize: "13px", mt: 1 }}>
                Every creation is crafted with passion and attention to detail
              </Typography>
            </Stack>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "70px",
              display: "flex",
              cursor: "pointer",

              "&:hover .icon-box": {
                transform: "scale(1.12)",
                bgcolor: "#ffe3b5ff",
              },

              //   "&:hover .icon": {
              //     transform: "scale(1.15)",
              //   },

              "&:hover .title": {
                color: "#F29C24",
              },
            }}
          >
            <Box
              className="icon-box"
              sx={{
                height: "50px",
                width: "50px",
                bgcolor: "#fff1dbff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
                transition: "all 0.3s ease",
              }}
            >
              <LeafIcon
                className="icon"
                sx={{
                  color: "#F29C24",
                  fontSize: 24,
                  transition: "transform 0.3s ease",
                }}
              />
            </Box>
            <Stack sx={{ ml: 3 }}>
              <Typography
                className="title"
                variant="h5"
                sx={{
                  fontSize: "18px",
                  fontWeight: 800,
                  transition: "color 0.3s ease",
                }}
              >
                Fresh Ingredients
              </Typography>
              <Typography sx={{ color: "#595959ff", fontSize: "13px", mt: 1 }}>
                We source only the finest, freshest ingredients locally
              </Typography>
            </Stack>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "70px",
              display: "flex",
              cursor: "pointer",

              "&:hover .icon-box": {
                transform: "scale(1.1)",
                bgcolor: "#ffe3b5ff",
              },

              //   "&:hover .icon": {
              //     transform: "scale(1.15)",
              //   },

              "&:hover .title": {
                color: "#F29C24",
              },
            }}
          >
            <Box
              className="icon-box"
              sx={{
                height: "50px",
                width: "50px",
                bgcolor: "#fff1dbff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
                transition: "all 0.3s ease",
              }}
            >
              <CakeOutlinedIcon
                className="icon"
                sx={{
                  color: "#F29C24",
                  fontSize: 28,
                  transition: "transform 0.3s ease",
                }}
              />
            </Box>
            <Stack sx={{ ml: 3 }}>
              <Typography
                className="title"
                variant="h5"
                sx={{
                  fontSize: "18px",
                  fontWeight: 800,
                  transition: "color 0.3s ease",
                }}
              >
                Custom Made Cakes
              </Typography>
              <Typography sx={{ color: "#595959ff", fontSize: "13px", mt: 1 }}>
                Designed to match your taste, theme, and special moments
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
